import {
  Component,
  Input,
  OnInit,
  HostListener,
  QueryList,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';

import { CalendarInnerComponent } from './calendar-inner.component';

@Component({
  selector: 'axis-calendar-yearpicker',
  templateUrl: './calendar.yearpicker.component.html'
})
export class YearPickerCalendarComponent implements OnInit {
  public calendar: CalendarInnerComponent;
  public title: string;
  public rows: any[] = [];
  public localeLanguage: string;
  public selectedYear: any;
  public selectedYearNumber: any;
  public validKeyPressed = false;

  @ViewChildren('yearRef') yearRef: QueryList<ViewContainerRef>;
  public constructor(
    calendar: CalendarInnerComponent,
  ) {
    this.calendar = calendar;
  }

  public ngOnInit(): void {
    this.calendar.yearSelected = true;
    let self: any = '';
    self = this;
    this.calendar.stepYear = { years: this.calendar.yearRange };
    this.calendar.setRefreshViewHandler(function (): void {
      this.years = new Array(this.yearRange);
      let date: Date;
      this.currentYear = this.activeDate.getFullYear();
      // currentYear : Defines the next possible year, while navigating across the yearPicker.
      this.start = this.start ? this.start : new Date().getFullYear();
      // start : Defines the first position of an year from where the years gets loaded in yearPicker.
      const inputValue = this._activeDate;
      this.startValue = new Date(inputValue).getFullYear();
      this.start = this.startValue;
      for (let i = 0; i < this.yearRange; i++) { // This loop loads the years on yearPicker in onload condition.
        date = new Date(this.start + i, 0, 1);
        date = this.fixTimeZone(date);
        this.years[i] = this.createDateObject(date, this.formatYear);
        this.years[i].uid = this.uniqueId + '-' + i;
      }

      if (this.years.length === this.yearRange) {
        const refYear = this.years[this.yearRange - 1].label;
        const selectedRefYear = parseInt(refYear, 10); // selectedRefYear : Gets the value of a last postioned year from the year picker.
        let startYear;
        if (this.currentYear > selectedRefYear) {
          // This condition loads the years on yearPicker while navigating yearPicker from present years to future years.
          this.start = selectedRefYear + 1;
          startYear = this.start;
        } else if (this.currentYear < this.start) {
          // This condition loads the years on yearPicker while navigating yearPicker from present years to past years.
          this.start = this.start - this.yearRange;
          startYear = this.start;
        } else {
          startYear = this.start;
        }

        for (let i = 0; i < this.yearRange; i++) {
          date = new Date(startYear + i, 0, 1);
          date = this.fixTimeZone(date);
          this.years[i] = this.createDateObject(date, this.formatYear);
          this.years[i].uid = this.uniqueId + '-' + i;
        }
      }

      self.title = [
        this.years[0].label,
        this.years[this.yearRange - 1].label
      ].join(' - ');

      self.rows = this.split(this.years, self.calendar.yearColLimit);
    }, 'year');

    this.calendar.setCompareHandler(function (
      date1: Date,
      date2: Date
    ): number {
      if (date1 !== null && date2 !== null) {
        return date1.getFullYear() - date2.getFullYear();
      }
    },
      'year');

    this.calendar.refreshView();
  }
  @HostListener('keyup', ['$event', 'this.yearRef'])
  onKeyUp(e: any, yearRef: any) {
    e.preventDefault();
    this.validKeyPressed = true;
    if ((e.code !== 'Tab' || e.keyCode !== 9) && this.calendar.datepickerMode === 'year') {
      this.yearUpdateOnKeyPress(yearRef, e);
    }
  }

  /**
  * Key events for the calendar.
  * TAB: moves focus to calendar.
  * LEFT_ARROW: Go to previous year.
  * RIGHT_ARROW: Go to next year.
  * UP_ARROW: Go up a row (back 4 years).
  * DOWN_ARROW:Go down a row (forward 4 years).
  * HOME: Go to the first year in the current range.
  * END: Go to the last year in the current range.
  * PAGE_UP: Go back 20 years
  * PAGE_DOWN:Go forward 20 years
  * ENTER:Select current year

  * @param event as KeyboardEvent
  */
  yearUpdateOnKeyPress(yearRef: any, e: any) {
    yearRef.forEach(element => {
      const tempElement = element.nativeElement;
      const selectedYearName = element.nativeElement.textContent;
      const selectedYearNumber = parseInt(selectedYearName, 10);
      this.selectedYear = new Date(selectedYearNumber, 0, 1);
      if (e.code === 'Home' || e.keyCode === 36) {
        this.selectedYearNumber = parseInt(this.calendar.yearpickerref.yearRef.first['nativeElement'].children[0].innerHTML, 10);
        this.selectedYear = new Date(this.selectedYearNumber, 0, 1);
        this.calendar.yearSelected = true;
      } else if (e.code === 'End' || e.keyCode === 35) {
        this.selectedYearNumber = parseInt(this.calendar.yearpickerref.yearRef.last['nativeElement'].children[0].innerHTML, 10);
        this.selectedYear = new Date(this.selectedYearNumber, 0, 1);
        this.calendar.yearSelected = true;
      } else if (tempElement.classList.contains('date-selected')) {
        if (e.code === 'ArrowRight' || e.keyCode === 39) {
          this.selectedYear.setFullYear(selectedYearNumber + 1);
        } else if (e.code === 'ArrowLeft' || e.keyCode === 37) {
          this.selectedYear.setFullYear(selectedYearNumber - 1);
        } else if (e.code === 'ArrowDown' || e.keyCode === 40) {
          this.selectedYear.setFullYear(selectedYearNumber + 5);
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
          this.selectedYear.setFullYear(selectedYearNumber - 5);
        } else if ((e.code === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
          this.selectedYearNumber = this.calendar['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() - 20, 0, 1);
        } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
          this.selectedYearNumber = this.calendar['_activeDate'];
          this.selectedYear = new Date(this.selectedYearNumber.getFullYear() + 20, 0, 1);
        } else {
          this.validKeyPressed = false;
        }

        if (this.validKeyPressed) {
          this.calendar.select(this.selectedYear, false);
        }

        this.calendar.yearSelected = true;
        if (e.code === 'Enter' || e.keyCode === 13) {
          this.calendar.select(this.selectedYear, true);
        }
      }
    });
  }
}
